import React, { useMemo } from 'react';
import PageLayout from '../../components/PageLayout';
import EkvairingPrivBlock from '../../components/EkvairingPrivBlock';

export default function FederationadministratorComissionEkvairingPriv(props) {
    // const x = useMemo(()=>({ organizatorFederatsiyaID: 1 }),[])
    return (
        <PageLayout>
            <div style={{ padding: "10px" }}>
                <EkvairingPrivBlock {...props} source={"/api/privatnienastroikiekvairinga/list"}
                    // sourceKey="fed"
                    create={true}
                    // ctx={x}
                />
            </div>
        </PageLayout>
    );
}
